import { create } from 'zustand';
import { useGameStore } from '@campus/core';

/**
 * Discussion de la bulle : fenêtre ouverte ou non (ProximityChatPanel) et
 * messages reçus pendant qu'elle était fermée (pastille du bouton « Bulle »).
 */
interface BubbleChatState {
  open: boolean;
  unread: number;
  /** Chat de la salle de réunion (ZoneRoom, meetingChat) : message épinglé, écriture réservée aux admins. */
  meeting: { bubbleId: string; pinnedId: string | null; locked: boolean } | null;
  setOpen: (open: boolean) => void;
}

export const useBubbleChatStore = create<BubbleChatState>((set) => ({
  open: false,
  unread: 0,
  meeting: null,
  setOpen: (open) => set(open ? { open, unread: 0 } : { open }),
}));

// Compte les messages des autres arrivés fenêtre fermée ; liste vidée
// (changement de bulle, plus personne à portée) = plus rien à lire.
useGameStore.subscribe((state, prev) => {
  const next = state.proximityMessages;
  const before = prev.proximityMessages;
  if (next === before) return;
  if (next.length === 0) { useBubbleChatStore.setState({ unread: 0 }); return; }
  const last = before[before.length - 1];
  const start = last ? next.lastIndexOf(last) + 1 : 0;
  const fresh = next.slice(start).filter((m) => !m.isSelf).length;
  if (fresh > 0 && !useBubbleChatStore.getState().open) {
    useBubbleChatStore.setState((s) => ({ unread: s.unread + fresh }));
  }
});
